import { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { X, Download, Copy } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function QRCodeModal({ open, onClose, links = [] }) {
  const { lang } = useI18n();
  const [active, setActive] = useState(0);
  const ref = useRef(null);
  if (!open) return null;
  const current = links[active] || {};

  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `${current.key || "qr"}.png`;
    a.click();
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(current.url || ""); } catch { /* noop */ }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-espresso/40 backdrop-blur-sm flex items-center justify-center px-4 py-6" data-testid="qr-modal">
      <div className="w-full max-w-lg bg-white rounded-3xl border border-espresso/10 shadow-[0_30px_80px_-30px_rgba(44,36,27,0.6)] p-6 md:p-8">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-serif text-3xl text-espresso">{lang === "en" ? "QR Codes" : "Mã QR"}</h3>
          <button type="button" onClick={onClose} data-testid="qr-close" className="text-espresso-muted hover:text-espresso">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex flex-wrap gap-2 mb-5">
          {links.map((l, i) => (
            <button
              key={l.key}
              type="button"
              data-testid={`qr-tab-${l.key}`}
              onClick={() => setActive(i)}
              className={`px-3.5 py-1.5 rounded-full text-xs font-medium transition-all ${
                i === active ? "bg-espresso text-linen" : "border border-espresso/15 text-espresso-soft hover:text-espresso"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
        <div ref={ref} className="bg-linen-100 rounded-2xl p-6 flex flex-col items-center">
          <QRCodeCanvas
            value={current.url || ""}
            size={240}
            bgColor="#FDFBF7"
            fgColor="#2C241B"
            level="M"
            includeMargin
          />
          <div className="mt-4 text-xs text-espresso-muted text-center break-all max-w-full">{current.url}</div>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={copy} data-testid="qr-copy" className="inline-flex items-center gap-1.5 border border-espresso/20 text-espresso px-4 py-2 rounded-full text-xs font-medium hover:bg-linen-200">
            <Copy className="w-3.5 h-3.5" /> {lang === "en" ? "Copy link" : "Copy link"}
          </button>
          <button type="button" onClick={download} data-testid="qr-download" className="inline-flex items-center gap-1.5 bg-espresso text-linen px-4 py-2 rounded-full text-xs font-medium hover:bg-espresso-hover">
            <Download className="w-3.5 h-3.5" /> {lang === "en" ? "Download PNG" : "Tải PNG"}
          </button>
        </div>
      </div>
    </div>
  );
}
